module.exports = __webpack_public_path__ + "img/46.c1ad92aa.jpg";